import React from 'react';
import styled from 'styled-components';
import { Divider } from 'antd';
import classNames from 'classnames';

const Wrap = styled.div<{ bgColor?: string }>`
  .anticon svg {
    display: block;
  }
  .divider {
    height: 16px;
    margin: 0px 6px 0px 9px;
    border-color: #ddd;
  }
  span#custom-icon {
    display: flex;
  }
  .global-custom-btn-style:hover {
    opacity: 0.9;
  }
  .disableBtn {
    opacity: 0.5;
    pointer-events: none;
  }
`;

interface ButtonProps {
  btnText: string;
  disabled: boolean;
  onClick: () => void;
  customIcon: React.ReactChild;
  borderRadius: string;
  fontSize: string;
  boxShadow: string;
  padding?: string; // Padding as a prop
  border?: string; // Border as a prop
  bgColor?: string; // Background color as a prop
  color?: string; // Color as a prop
  width?: string;
}

const GlobalCustomButton: React.FC<ButtonProps> = ({
  disabled,
  btnText,
  onClick,
  customIcon,
  padding, // Padding as a prop
  border, // Border as a prop
  bgColor, // Background color as a prop
  color, // Color as a prop
  borderRadius,
  fontSize,
  boxShadow,
  width,
}) => {
  const customStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    fontFamily: 'Roboto',
    width: width,
    maxHeight: '38px',
    lineHeight: '20px',
    padding: padding || '8px 16px', // Default padding or use prop value
    border: border || '1px solid #DADADA', // Default border or use prop value
    color: color || '#222326', // Default color or use prop value
    fontSize,
    boxShadow,
    background: bgColor || 'transparent', // Default background color or use prop value
    borderRadius: borderRadius || '4px',
    fontWeight: 500,
  };

  return (
    <Wrap>
      <button
        type="button"
        style={customStyle}
        className={classNames('global-custom-btn-style', { disableBtn: disabled })}
        disabled={disabled}
        onClick={onClick}
      >
        {btnText} <Divider type="vertical" className="divider" />
        <span id="custom-icon">{customIcon}</span>
      </button>
    </Wrap>
  );
};

export default GlobalCustomButton;
